// extracted by mini-css-extract-plugin
export default {"container":"lM-z","modal":"mM-z","dimensions":"nM-z","brandName":"oM-z","productName":"pM-z","labelValue":"qM-z","recipientEmail":"rM-z","recommendedFit":"sM-z","hiddenField":"tM-z"};